import { create } from 'zustand';

const useUploadStore = create((set) => ({
  // Simple in-memory state
  uploadStatus: {},
  uploadProgress: {},
  isUploading: false,

  // Basic actions
  updateUpload: (filename, { status, progress }) => set(state => ({
    uploadStatus: {
      ...state.uploadStatus,
      [filename]: status
    },
    uploadProgress: {
      ...state.uploadProgress,
      [filename]: progress
    },
    isUploading: Object.values({
      ...state.uploadStatus,
      [filename]: status
    }).includes('uploading')
  })),

  // Reset state
  resetUploads: () => set({
    uploadStatus: {},
    uploadProgress: {},
    isUploading: false
  })
}));

export default useUploadStore;
